module.exports = __webpack_public_path__ + "static/img/暖通.9ce263b4.png";